export function getTagNames(location) {
    const tags = []

    if (location.price <= 5) tags.push({ text: t('tags.cheap'), id: 'cheap' });
    if (location.hasStampcard == true) tags.push({ text: t('tags.stampcard'), id: 'stampcard' });
    if (location.hasStampcard == true) tags.push({ text: t('tags.card'), id: 'cardPayment' });
    if (location.isVegan == true) tags.push({ text: t('tags.vegan'), id: 'veganOptions' });
    if (location.isVegetarian == true) tags.push({ text: t('tags.veggie'), id: 'veggieOptions' });
    if (location.isGlutenfree == true) tags.push({ text: t('tags.glutenfree'), id: 'glutenfree' });
    if (location.facilities) {
        if (location.facilities.halalOptions == true) tags.push({ text: t('tags.halal'), id: 'halal' });
        if (location.facilities.delivery == true) tags.push({ text: t('tags.delivery'), id: 'delivery' });
        if (location.facilities.toilets == true) tags.push({ text: t('tags.toilets'), id: 'toilets' });
        if (location.facilities.outdoor == true) tags.push({ text: t('tags.outdoor'), id: 'outdoorSeating' });
        if (location.facilities.parking == true) tags.push({ text: t('tags.parking'), id: 'parkingNearby' });
        if (location.facilities.wheelchair == true) tags.push({ text: t('tags.wheelchair'), id: 'wheelchairAccessible' });
        if (location.facilities.realDoner == true) tags.push({ text: t('tags.realDoner'), id: 'realDoner' });
    }
    return tags;
}

export function getTags(location, callback) {
    return getTagNames(location).map((tag) => {
        return createBadge(tag.text, tag.id, callback);
    })
}

export function getMissingTagNames(location) {
    const tags = [];

    if (location.price >= 8) tags.push({ text: t('tags.expensive'), id: 'expensive' });
    if (location.hasStampcard != true) tags.push({ text: t('tags.noStampcard'), id: 'noStampcard' });
    if (location.isVegan != true) tags.push({ text: t('tags.noVegan'), id: 'noVeganOptions' });
    if (location.isVegetarian != true) tags.push({ text: t('tags.noVeggie'), id: 'noVeggieOptions' });
    if (location.isGlutenfree != true) tags.push({ text: t('tags.noGlutenfree'), id: 'noGlutenfree' });
    if (location.hasStampcard != true) tags.push({ text: t('tags.noCard'), id: 'noCardPayment' });

    if (location.facilities) {
        if (location.facilities.halalOptions != true) tags.push({ text: t('tags.noHalal'), id: 'noHalal' });
        if (location.facilities.delivery != true) tags.push({ text: t('tags.noDelivery'), id: 'noDelivery' });
        if (location.facilities.toilets != true) tags.push({ text: t('tags.noToilets'), id: 'noToilets' });
        if (location.facilities.outdoor != true) tags.push({ text: t('tags.noOutdoor'), id: 'noOutdoorSeating' });
        if (location.facilities.parking != true) tags.push({ text: t('tags.noParking'), id: 'noParkingNearby' });
        if (location.facilities.wheelchair != true) tags.push({ text: t('tags.noWheelchair'), id: 'noWheelchairAccessible' });
    }
    return tags;
}

export function getMissingTags(location) {
    return getMissingTagNames(location).map((tag) => {
        return createBadge(tag.text, tag.id);
    })
}

export function createBadge(text, id, callback = null, color = 'badge-accent', icon = 'fa-solid fa-filter', title = `Filter by ${text}`) {
    const badge = document.createElement('span');
    badge.classList.add('badge', color, 'text-gray-100', 'cursor-pointer', 'hover:badge-primary', 'transition-colors', 'duration-200', 'min-w-fit'); 
    
    // Add filter icon to indicate the badge is clickable
    badge.innerHTML = `<i class="${icon} fa-xs mr-1"></i>${text}`;

    if (callback != null && typeof callback === 'function') {
        // Add title attribute for tooltip
        badge.title = title;
        
        // Add visual feedback on hover
        badge.addEventListener('mouseover', () => {
            badge.classList.add('scale-105');
        });
        
        badge.addEventListener('mouseout', () => {
            badge.classList.remove('scale-105');
        });
        
        badge.onclick = (event) => {
            event.stopPropagation();
            callback(text, id);
        };
    }

    return badge;
}